module.exports = __webpack_public_path__ + "img/GP_1Germany_FemaleAccelerator.5985f86c.png";